import React from 'react'

export const LayoutContentAreas = {
  Boxed: 'Boxed',
  BoxedMenu: 'BoxedMenu',
  Blank: 'Blank',
  BlankMenu: 'BlankMenu',
  All: 'All',
  AllMenu: 'AllMenu',
  AllDynamic: 'AllDynamic'
}

export function LayoutContent (props) {
  const { children } = props

  return <div data-tid='LayoutContent'>
    {children}
  </div>
}

export default LayoutContent
